import { render, staticRenderFns } from "./PopupTeacher.vue?vue&type=template&id=46db0559&scoped=true&"
import script from "./PopupTeacher.vue?vue&type=script&lang=js&"
export * from "./PopupTeacher.vue?vue&type=script&lang=js&"
import style0 from "./PopupTeacher.vue?vue&type=style&index=0&id=46db0559&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db0559",
  null
  
)

export default component.exports